
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { IGroupResponseMessage, IScreenGroup } from '../../models';
import { CommonService, ScreenService, ToasterService } from '../../services';
import { Constants, GlobalSettings } from '../../common';
import { HttpErrorResponse } from '@angular/common/http';
import { MatCardContent } from '@angular/material/card';

@Component({
  selector: 'app-add-group',
  imports: [
    MatDialogModule,
    MatFormFieldModule,
    MatCardContent,
    FormsModule,
    MatButtonModule,
    MatInputModule,
    ReactiveFormsModule
  ],
  templateUrl: './add-group.component.html',
  styleUrl: './add-group.component.scss'
})
export class AddGroupComponent implements OnInit, AfterViewInit {

  limits = GlobalSettings.characterLimits;

  @Input() currentGroup: IScreenGroup = {} as IScreenGroup;
  @Input() isUpdateGroup = false;

  @Output() closeEvent = new EventEmitter<string>();

  @ViewChild('nameInput') nameInput!: ElementRef<HTMLInputElement>;

  editGroupForm!: FormGroup;

  constructor(private fb: FormBuilder, private commonService: CommonService, private screenService: ScreenService, private toaster: ToasterService) { }

  ngOnInit(): void {
    this.initializeForms();
  }

  ngAfterViewInit() {
    // Focus and select all text in the name input field
    this.nameInput.nativeElement.focus();
    // this.nameInput.nativeElement.select();
  }

  initializeForms() {
    const currentGroup: IScreenGroup = this.currentGroup ? this.currentGroup : {} as IScreenGroup
    this.editGroupForm = this.fb.group({
      id: [currentGroup.id],
      name: [currentGroup.name, [Validators.required]],
      description: [currentGroup.description]
    });
  }

  getFormHeight() {
    return window.innerHeight - 280;
  }

  onFormSubmit() {
    const noEmptySpace = this.editGroupForm.value.name.trim();
    if (this.editGroupForm.valid && noEmptySpace) {
      this.commonService.isLoading = true;
      if (this.isUpdateGroup) {
        this.screenService.updateScreenGroup(this.currentGroup.id, this.editGroupForm.value).subscribe({
          next: (response: IGroupResponseMessage) => {
            // console.log(response);
            this.commonService.isLoading = false;
            this.closeEvent.emit('success');
            this.toaster.success(response?.message?.message ? response.message.message : Constants.notifyMessages.updateSuccessScreenGroup);
          },
          error: (error: HttpErrorResponse) => {
            this.commonService.isLoading = false;
            console.log(error);
            this.toaster.error(error?.error?.message ? error.error.message : Constants.notifyMessages.updateErrorScreenGroup);
          }
        })
      }
      else {
        this.screenService.addScreenGroup(this.editGroupForm.value).subscribe({
          next: (response: IGroupResponseMessage) => {
            // console.log(response);
            this.commonService.isLoading = false;
            this.closeEvent.emit(response.message.group_id.toString());
            this.toaster.success(response?.message?.message ? response.message.message : Constants.notifyMessages.addSuccessScreenGroup);
          },
          error: (error: HttpErrorResponse) => {
            this.commonService.isLoading = false;
            console.log(error);
            this.toaster.error(error?.error?.message ? error.error.message : Constants.notifyMessages.addErrorScreenGroup);
          }
        })
      }
    }
    else {
      if (!this.editGroupForm.valid) {
        this.toaster.warning(Constants.notifyMessages.invalidForm);
      }
      else if (!noEmptySpace) {
        this.toaster.warning(Constants.notifyMessages.emptyValues);
      }
      Object.values(this.editGroupForm.controls).forEach(control => {
        control.markAsTouched();
      });
    }
  }

  cancelClick() {
    this.closeEvent.emit('close');
  }
}
